import React, {useState} from 'react'
import Header from './header'
import './portfolio.css';
import Welcome from './welcome';
import About from './about';
import Skill from './skill';
import PopUpBox from '../../component/PopUpBox'
import Experience from './experience';
import Works from './works';
import Footer from './Footer';
import { LanguageProvider } from '../../i18n/LanguageContext';

export default function Portfolio() {
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState('')
  return (
    <LanguageProvider>
      <div>
        <Header/>
        <Welcome/>
        <About/>
        <Skill open={open} setOpen={setOpen} setContent={setContent}/>
        <Experience/>
        <Works/>
        <Footer/>
        <PopUpBox open={open} setOpen={setOpen} content={content}/>
      </div>
    </LanguageProvider>
  )
}
